import React, { useState } from 'react';

import env from '../../config/env';

const appUrl = env.BRIZI_API_AUTHORITY
  && `${env.HTTP_PROTOCOL}${env.BRIZI_API_AUTHORITY.replace('api', env.BRIZI_APP_SLUG)}`;

const AppUrlButton = () => {
  const [copied, setCopied] = useState(false);

  if (!appUrl) return null;

  return (
    <button
      type="button"
      title={copied ? 'Copied!' : 'Copy app URL'}
      onClick={() => {
        navigator.clipboard.writeText(appUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
      }}
      style={{
        position: 'fixed',
        right: 20,
        bottom: 20,
        zIndex: 1000,
        padding: '8px 12px',
        border: 'none',
        borderRadius: 30,
        background: 'var(--theme-yellow)',
        color: '#fff',
        fontSize: 12,
        fontWeight: 'bold',
        cursor: 'pointer',
      }}
    >
      <span style={{ visibility: copied ? 'hidden' : 'visible' }}>{appUrl}</span>
      {copied && (
        <span
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          Copied!
        </span>
      )}
    </button>
  );
};

export default AppUrlButton;
